
export const saveLog = async ({ action, module, status = "S" }) => {
  try {
    // ===== Get Company =====
    const company = JSON.parse(localStorage.getItem("selectedCompany"));
    const compId = company?.id;

    // ===== Get User Info =====
    const userId = localStorage.getItem("userId");
    const username = localStorage.getItem("username");
    const userType = localStorage.getItem("userType"); // 0 = Admin, 1 = User

    if (!compId || !userId) {
      console.log("Log skipped: Missing CompID or UserID");
      return;
    }


    const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
    // ===== Action Text =====
    const actionText = getActionText(action);

    // ===== Role Check (Based on your system) =====
    let roleLabel = "User";

    if (userType === "0" || userType === 0) {
      roleLabel = "Admin";
    } else if (userType === "1" || userType === 1) {
      roleLabel = "User";
    }

    const displayName = username || `User ${userId}`;

    // ===== Final Remark =====
    const remarkText = `${module} ${actionText} by ${roleLabel} ${displayName}`;

    // ===== Payload =====
    const payload = {
      CompID: Number(compId),
      iUserID: Number(userId),
      Remark: remarkText,
      RemarkType: status,
    };

    console.log("Log Payload:", payload);

    const res = await fetch(`${BASE_API_URL}/logs/save_logs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      console.error("Log API failed:", data);
    } else {
      console.log("Log saved:", remarkText);
    }
  } catch (error) {
    console.error("Log API error:", error);
  }
};

// ===== Helper =====
const getActionText = (action) => {
  const a = String(action).toUpperCase();

  if (a === "A") return "Created";
  if (a === "E") return "Updated";
  if (a === "D") return "Deleted";
  return "Action";
};






// export const saveLog = async ({ action, module, status = "S" }) => {
//   try {
//     // ===== Get Company =====
//     const company = JSON.parse(localStorage.getItem("selectedCompany"));
//     const compId = company?.id;

//     // ===== Get User =====
//     const userId = localStorage.getItem("userId");
//     const username = localStorage.getItem("username"); // NEW

//     if (!compId || !userId) {
//       console.log("Log skipped: Missing CompID or UserID");
//       return;
//     }

//     // ===== Action Text =====
//     const actionText = getActionText(action);

//     // ===== Final Remark (Show username if available) =====
//     const userDisplayName = username || `User ${userId}`;

//     const remarkText = `${module} ${actionText} by ${userDisplayName}`;

//     // ===== Data to API =====
//     const payload = {
//       CompID: Number(compId),
//       iUserID: Number(userId),
//       Remark: remarkText,
//       RemarkType: status, // S = Success, E = Error
//     };

//     console.log("Log Payload:", payload);

//     const res = await fetch("http://localhost:5000/api/logs/save_logs", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(payload),
//     });

//     const data = await res.json();

//     if (!res.ok) {
//       console.error("Log API failed:", data);
//     } else {
//       console.log("Log saved:", remarkText);
//     }
//   } catch (error) {
//     console.error("Log API error:", error);
//   }
// };

// // ===== Helper =====
// const getActionText = (action) => {
//   const a = String(action).toUpperCase();

//   if (a === "A") return "Created";
//   if (a === "E") return "Updated";
//   if (a === "D") return "Deleted";
//   return "Action";
// };